<template>
  <div class="analysis">
    <Header></Header>
    <div class="analysis-banner flex-row">
      <div class="container business-banner-title">
        <p>产业大数据分析</p>
        <p>
          近400人大数据尖端科研团队，让产业招商更简单、更省时、更省力。
        </p>
      </div>
    </div>
    <div class="analysis-develop">
      <p class="develop-intro container">
        围绕政府<span>产业招商及落地、园区运营管理</span>等一系列需求，依托<span>海量数据</span>，实时抓取分析<span>300多万家规模企业</span>有效数据，用科技全面赋能政企对接，数智化助力园区发展。
      </p>
      <div class="container flex-row intro-list">
        <div class="intro-item flex-col">
          <p>2700+</p>
          <p>精准产业链标签</p>
        </div>
        <div class="intro-item flex-col">
          <p>2.5万+</p>
          <p>产品标签目录</p>
        </div>
        <div class="intro-item flex-col">
          <p>1万+</p>
          <p>上市及挂牌企业</p>
        </div>
        <div class="intro-item flex-col">
          <p>15万+</p>
          <p>融资企业</p>
        </div>
        <div class="intro-item flex-col">
          <p>50万+</p>
          <p>龙头配套供应链企业</p>
        </div>
        <div class="intro-item flex-col">
          <p>80万+</p>
          <p>专精特新及科技型企业</p>
        </div>
      </div>
    </div>
    <div class="analysis-platform">
      <p class="platform-title">产业链数智化招商平台</p>
      <div class="container flex-row">
        <div class="platform-left">
          <div
            class="flex-col"
            @click="current = '产业地图'"
            :style="
              current == '产业地图'
                ? 'width:340px;background:url(' +
                  require('@/assets/images/business/map-choose-bg.png') +
                  ')'
                : 'width:330px;height:178px'
            "
          >
            <p :style="current == '产业地图' ? 'color:#fff' : ''">
              <img
                :src="
                  current == '产业地图'
                    ? require('@/assets/images/business/platform1-active.png')
                    : require('@/assets/images/business/platform1.png')
                "
                alt=""
              />&nbsp;产业地图
            </p>
            <div class="platform-intro" v-show="current == '产业地图'">
              实时动态的产业数据展示，呈现区域规划和发展成果，实现规划落图、资源落图。
            </div>
          </div>
          <div
            class="flex-col"
            @click="current = '产业链图谱'"
            :style="
              current == '产业链图谱'
                ? 'width:340px;background:url(' +
                  require('@/assets/images/business/map-choose-bg.png') +
                  ')'
                : 'width:330px;height:178px'
            "
          >
            <p :style="current == '产业链图谱' ? 'color:#fff' : ''">
              <img
                :src="
                  current == '产业链图谱'
                    ? require('@/assets/images/business/platform2-active.png')
                    : require('@/assets/images/business/platform2.png')
                "
                alt=""
              />&nbsp;产业链图谱
            </p>
            <div class="platform-intro" v-show="current == '产业链图谱'">
              产业链结构全景、可视化展示，定位缺失环节，智能推荐企业。
            </div>
          </div>
          <div
            class="flex-col"
            @click="current = '招商管理'"
            :style="
              current == '招商管理'
                ? 'width:340px;background:url(' +
                  require('@/assets/images/business/map-choose-bg.png') +
                  ')'
                : 'width:330px;height:178px'
            "
          >
            <p :style="current == '招商管理' ? 'color:#fff' : ''">
              <img
                :src="
                  current == '招商管理'
                    ? require('@/assets/images/business/platform3-active.png')
                    : require('@/assets/images/business/platform3.png')
                "
                alt=""
              />&nbsp;招商管理
            </p>
            <div class="platform-intro" v-show="current == '招商管理'">
              支持项目调度、项目督办，打造一体化项目管理体系，提升招商管理质效。
            </div>
          </div>
        </div>
        <div
          v-show="current == '产业地图'"
          class="platform-right"
          :style="
            'background: url(' +
              require('@/assets/images/business/map1-bg.png') +
              ')'
          "
        >
          <img
            class="service-item flex-col"
            :class="current == '产业地图'?'wow animate__animated animate__fadeInLeft':''"
            data-wow-delay="0"
            data-wow-offset="5"
            width="253"
            style="left:-30px;top:100px;"
            src="@/assets/images/business/map-1.png"
            alt=""
          />
          <img
            class="service-item flex-col"
            :class="current == '产业地图'?'wow animate__animated animate__fadeInRight':''"
            data-wow-delay="0"
            data-wow-offset="5"
            width="374"
            style="right:-20px;bottom:-70px;"
            src="@/assets/images/business/map-2.png"
            alt=""
          />
        </div>
        <div
          v-show="current == '产业链图谱'"
          class="platform-right"
          :style="
            'background: url(' +
              require('@/assets/images/business/map2-bg.png') +
              ')'
          "
        >
          <img
            class="service-item flex-col"
            :class="current == '产业链图谱'?'animate__animated animate__fadeInLeft':''"
            width="253"
            style="left:-30px;bottom:100px;"
            src="@/assets/images/business/map-3.png"
            alt=""
          />
          <img
            class="service-item flex-col"
            :class="current == '产业链图谱'?'animate__animated animate__fadeInRight':''"
            width="374"
            style="right:-30px;bottom:-70px;"
            src="@/assets/images/business/map-4.png"
            alt=""
          />
        </div>
        <div
          v-show="current == '招商管理'"
          class="platform-right"
          :style="
            'background: url(' +
              require('@/assets/images/business/map3-bg.png') +
              ')'
          "
        >
          <img
            class="service-item flex-col"
            :class="current == '招商管理'?'animate__animated animate__fadeInLeft':''"
            width="253"
            style="right:-30px;bottom:-80px;"
            src="@/assets/images/business/map-5.png"
            alt=""
          />
        </div>
      </div>
    </div>
    <div class="analysis-manage">
      <p class="manage-title">园区实景三维信息+产业链智能化管理平台</p>
      <p>全高清设备采集，园区运营多维度、数字化展示</p>
      <div style="margin-top:40px" class="container flex-row">
        <div>
          <div
            class="manage-left flex-row"
            :class="currentManage == '三维' ? 'manage-active' : ''"
            @click="chooseManage('三维', 0)"
          >
            <img
              :src="
                currentManage == '三维'
                  ? require('@/assets/images/business/manage1-active.png')
                  : require('@/assets/images/business/manage-1.png')
              "
              alt=""
            />&nbsp;三维环视 园区直观展示
          </div>
          <div
            class="manage-left flex-row"
            :class="currentManage == '产业' ? 'manage-active' : ''"
            @click="chooseManage('产业', 1)"
          >
            <img
              :src="
                currentManage == '产业'
                  ? require('@/assets/images/business/manage2-active.png')
                  : require('@/assets/images/business/manage-2.png')
              "
              alt=""
            />&nbsp;产业全链条数据化分析研判
          </div>
          <div
            class="manage-left flex-row"
            :class="currentManage == '调查' ? 'manage-active' : ''"
            @click="chooseManage('调查', 2)"
          >
            <img
              :src="
                currentManage == '调查'
                  ? require('@/assets/images/business/manage3-active.png')
                  : require('@/assets/images/business/manage-3.png')
              "
              alt=""
            />&nbsp; 调查测绘、空地建模等园区规划预览
          </div>
          <div
            class="manage-left flex-row"
            :class="currentManage == '水电' ? 'manage-active' : ''"
            @click="chooseManage('水电', 3)"
          >
            <img
              :src="
                currentManage == '水电'
                  ? require('@/assets/images/business/manage4-active.png')
                  : require('@/assets/images/business/manage-4.png')
              "
              alt=""
            />&nbsp; 水电、交通、环境、教育配套全览
          </div>
          <div
            class="manage-left flex-row"
            :class="currentManage == '政策' ? 'manage-active' : ''"
            @click="chooseManage('政策', 4)"
          >
            <img
              :src="
                currentManage == '政策'
                  ? require('@/assets/images/business/manage5-active.png')
                  : require('@/assets/images/business/manage-5.png')
              "
              alt=""
            />&nbsp;政策效用全景分析
          </div>
        </div>
        <img
          v-show="currentManage == '三维'"
          class="manage-right wow animate__animated animate__fadeInUp"
          data-wow-delay="0"
          data-wow-offset="5"
          :src="require('@/assets/images/business/manage1-bg.png')"
        />
        <img
          v-show="currentManage == '产业'"
          class="manage-right"
          :src="require('@/assets/images/business/manage2-bg.png')"
        />
        <img
          v-show="currentManage == '调查'"
          class="manage-right"
          :src="require('@/assets/images/business/manage3-bg.png')"
        />
        <img
          v-show="currentManage == '水电'"
          class="manage-right"
          :src="require('@/assets/images/business/manage4-bg.png')"
        />
        <img
          v-show="currentManage == '政策'"
          class="manage-right"
          :src="require('@/assets/images/business/manage5-bg.png')"
        />
      </div>
    </div>
    <div class="analysis-cloud">
      <p class="cloud-title">智能招商云平台</p>
      <div class="container flex-row">
        <div class="cloud-intro">
          <p>每日精准推荐招商线索</p>
          <p>业内独家大数据招商情报系统，数据量大、发布迅速、精准性高</p>
        </div>
        <div class="cloud-right1">
          <img
            class="wow animate__animated animate__fadeInRight"
            height="60"
            style="right:-20px;top:140px;"
            src="@/assets/images/business/cloud-2.png"
            alt=""
          />
        </div>
      </div>
      <br /><br /><br />
      <div class="container flex-row">
        <div class="cloud-right2">
          <img
            class="wow animate__animated animate__fadeInLeft"
            height="130"
            style="right:-20px;top:200px;"
            src="@/assets/images/business/cloud-4.png"
            alt=""
          />
        </div>
        <div class="cloud-intro">
          <p>项目引荐&资源对接</p>
          <p>
            庞大精准的项目负责人数据库，一对一顾问式服务，定制化产业资源对接
          </p>
        </div>
      </div>
    </div>
    <div class="analysis-patent">
      <p class="patent-title">软著及专利</p>
      <div class="patent flex-row">
        <div class="patent-mask" style="left:0;top:0"></div>
        <div class="patent-mask" style="right:0;top:0"></div>
        <div v-for="(i, index) in patentList" :key="index" class="patent-item">
          <img :src="i" alt="" />
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import "@/assets/css/analysis.css";
import Header from "./Header";
import Footer from "./Footer";
export default {
  name: "Analysis",
  components: {
    Header,
    Footer
  },
  data() {
    return {
      current: "产业地图",
      currentManage: "三维",
      patentList: [
        require("@/assets/images/business/patentleft-1.png"),
        require("@/assets/images/business/patentleft-2.png"),
        require("@/assets/images/business/patentleft-3.png"),
        require("@/assets/images/business/patentleft-4.png"),

        require("@/assets/images/business/patent-1.png"),
        require("@/assets/images/business/patent-2.png"),
        require("@/assets/images/business/patent-3.png"),
        require("@/assets/images/business/patent-4.png"),
        require("@/assets/images/business/patent-5.png"),
        require("@/assets/images/business/patent-6.png"),
        require("@/assets/images/business/patent-7.png"),
        require("@/assets/images/business/patent-8.png"),
        require("@/assets/images/business/patent-9.png"),
        require("@/assets/images/business/patent-10.png"),
        require("@/assets/images/business/patent-11.png"),
        require("@/assets/images/business/patent-12.png"),

        require("@/assets/images/business/patentright-1.png"),
        require("@/assets/images/business/patentright-2.png"),
        require("@/assets/images/business/patentright-3.png"),
        require("@/assets/images/business/patentright-4.png")
      ]
    };
  },
  created() {},
  mounted() {
    var wow = new this.$wow.WOW({
      boxClass: "wow",
      animateClass: "animated",
      offset: 200,
      mobile: false,
      live: true
    });
    wow.init();
  },
  methods: {
    chooseManage(val, index) {
      this.currentManage = val;
      setTimeout(() => {
        if (
          document
            .getElementsByClassName("manage-right")
            [index].className.indexOf("wow") == -1
        ) {
          document.getElementsByClassName("manage-right")[index].style =
            "transform:translateY(-101px)";
        }
      }, 100);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Analysis.vue